import React, {Component} from 'react';
import {AppHeader} from "../../ui/appHeader";
import {
    AuthProvider,
    CartProvider,
    CheckoutProvider,
    MarketingProvider,
    OrderIntentProvider,
    ServiceTypesProvider
} from "../../providers";
import {UIProvider} from "../../providers";
import {FlyOverCart} from "../../ui/flyOverCart";
import {UserSignInModal} from "../../ui/userSignInModal";
import {CategoryNavigation} from "../../ui/categoryNavigation";
import {GlobalToast} from "../../ui/toast";
import {OrderIntentNavbar} from "../../ui/orderIntentNavbar";
import {SuggestiveSellDialog} from "../../ui/suggestiveSell";
import {PageBottomFooter} from "../../ui/pageBottomFooter";
import {DistantLocationWarning} from "../../ui/distantLocationWarning";
export default class AppContent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"app-content-background"}>
                <UIProvider>
                    <ServiceTypesProvider>
                        <OrderIntentProvider>
                            <AuthProvider>
                                <CheckoutProvider>
                                    <MarketingProvider>
                                        <CartProvider>
                                        <AppHeader
                                            homeHref={`${window.relativeURI()}/menu`}
                                            companyName={session.store.name}
                                            sticky={true}
                                            stickyTop={0}
                                            logoSrc={session.store_branding.brand_logo_banner}
                                            logoAlt={`${session.store.name} logo.`}
                                            key={'cart-provider'}
                                            cartHref={`${window.relativeURI()}/cart`}
                                        />
                                        <OrderIntentNavbar />
                                        <FlyOverCart />
                                        <CategoryNavigation categories={session.categories} />
                                        <UserSignInModal />
                                        <GlobalToast />
                                        <SuggestiveSellDialog />
                                        <DistantLocationWarning />
                                        <div className={"app-content-wrapper"}>
                                            {this.props.children}
                                        </div>
                                        <PageBottomFooter />
                                        </CartProvider>
                                    </MarketingProvider>
                                </CheckoutProvider>
                            </AuthProvider>
                        </OrderIntentProvider>
                    </ServiceTypesProvider>
                </UIProvider>
            </div>
        );
    }
}
